import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { Sparkles, Plus } from "lucide-react";
import { toast } from "sonner";

export default function CatalogSuggestions({ onAdded }) {
  const { activeBoat } = useAuth();
  const isHousehold = activeBoat?.kind === "household";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState({});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getCatalogSuggestions(20);
        if (!cancelled) setItems(res.data || []);
      } catch {
        /* swallow — suggestions are optional */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleAdd = async (it) => {
    setBusy((b) => ({ ...b, [it.id]: true }));
    try {
      await api.catalogAddToShopping(it.id);
      toast.success(`${it.name} lagt til`);
      onAdded && onAdded();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Feil");
    } finally {
      setBusy((b) => ({ ...b, [it.id]: false }));
    }
  };

  if (loading || items.length === 0) return null;

  return (
    <div className="mt-6 bg-sailcloth-100/50 border border-stone-200 rounded-xl p-5" data-testid="catalog-suggestions">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="h-4 w-4 text-navy-800" />
        <h3 className="text-xs uppercase tracking-[0.2em] text-navy-800 font-semibold">Foreslåtte varer</h3>
        <span className="text-xs text-stone-500 ml-2">basert på mest brukte varer {isHousehold ? "i husstanden" : "på tvers av båter"}</span>
      </div>
      <div className="flex gap-2 flex-wrap">
        {items.map((it) => (
          <button
            key={it.id}
            onClick={() => handleAdd(it)}
            disabled={busy[it.id]}
            className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-white px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-navy-800 hover:text-white hover:border-navy-800 transition-all disabled:opacity-50"
            data-testid={`suggestion-${it.id}`}
            title={`${it.category} – brukt ${it.count}×`}
          >
            <Plus className="h-3 w-3" /> {it.name}
          </button>
        ))}
      </div>
    </div>
  );
}
